module.exports = __webpack_public_path__ + "static/Law of Jurisdiction (of Courts & Tribunals)-1597138a717b7bf538e117762bc38eaf.jpg";